import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const AGE_KEY = "ne_age_confirmed_v1";

export default function AgeGate({ onConfirm }) {
  const { t } = useTranslation();
  const [over18, setOver18] = useState(false);
  const [accept, setAccept] = useState(false);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const v = typeof window !== "undefined" && localStorage.getItem(AGE_KEY);
    if (v === "yes") setShow(false);
  }, []);

  if (!show) return null;

  const ready = over18 && accept;
  const confirm = () => {
    if (!ready) return;
    localStorage.setItem(AGE_KEY, "yes");
    setShow(false);
    onConfirm?.();
  };
  const exit = () => { window.location.href = "https://www.google.com"; };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4" data-testid="age-gate">
      <div className="absolute inset-0 bg-[#050505]" />
      <div className="absolute inset-0" style={{
        background: "radial-gradient(700px 400px at 50% 30%, rgba(247,24,104,0.12), transparent 60%)"
      }} />

      <div className="relative max-w-xl w-full animate-fade-up">
        {/* Språkvelger – øverst til høyre. La besøkende fra Sverige/Danmark/utlandet
            bytte språk før de signerer 18+-bekreftelsen. */}
        <div className="absolute -top-2 right-0 z-10" data-testid="age-gate-language">
          <LanguageSwitcher variant="header" />
        </div>

        <div className="text-center mb-10">
          <div className="font-meta mb-6" data-testid="age-gate-volume">VOL. I · 2026</div>
          <div className="font-script text-[var(--magenta)] text-7xl sm:text-8xl leading-none mb-3" data-testid="age-gate-brand"
               style={{ textShadow: "0 0 50px rgba(247,24,104,0.25)" }}>
            Norsk Erotikk
          </div>
          <div className="font-fraunces italic text-[var(--cream)] text-xl">
            {t("age_gate.tagline")}
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="font-meta text-center mb-3">{t("age_gate.confirm_title")}</div>
          <h1 className="font-fraunces italic text-3xl sm:text-4xl text-[var(--cream)] text-center leading-tight mb-5">
            {t("age_gate.are_you_over_18")}
          </h1>
          <p className="text-[var(--cream-soft)] text-sm leading-relaxed text-center mb-8 max-w-md mx-auto font-manrope">
            {t("age_gate.intro")}
          </p>

          <div className="space-y-4 mb-10 max-w-md mx-auto">
            <label className="flex items-start gap-3 cursor-pointer text-sm text-[var(--cream)] font-manrope">
              <input type="checkbox" checked={over18} onChange={(e)=>setOver18(e.target.checked)}
                className="mt-0.5 h-4 w-4 accent-[var(--magenta)] cursor-pointer"
                data-testid="age-gate-over18" />
              <span>{t("age_gate.i_am_over_18")}</span>
            </label>
            <label className="flex items-start gap-3 cursor-pointer text-sm text-[var(--cream)] font-manrope">
              <input type="checkbox" checked={accept} onChange={(e)=>setAccept(e.target.checked)}
                className="mt-0.5 h-4 w-4 accent-[var(--magenta)] cursor-pointer"
                data-testid="age-gate-terms" />
              <span>
                {t("age_gate.consent_prefix")}{" "}
                <span className="text-[var(--magenta)] underline-offset-4 underline decoration-[var(--magenta)]/40">{t("age_gate.terms_word")}</span>{" "}
                {t("age_gate.consent_suffix")}
              </span>
            </label>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <button onClick={confirm} disabled={!ready}
              className="btn-magenta flex-1" data-testid="age-gate-enter">
              {t("age_gate.enter")}
            </button>
            <button onClick={exit} className="btn-ghost" data-testid="age-gate-exit">
              {t("age_gate.leave")}
            </button>
          </div>

          <p className="text-[10px] text-[var(--cream-faint)] uppercase tracking-[0.2em] text-center mt-10 font-manrope">
            {t("age_gate.zero_tolerance")}
          </p>
        </div>
      </div>
    </div>
  );
}
